import { PropsWithChildren } from "react";

interface IProps extends PropsWithChildren {
  className?: string;
}

export const CreateNewRowWrapper = (props: IProps) => {
  const { className } = props;

  const classes = `d-flex align-items-center flex-column flex-lg-row flex-nowrap gap-1 gap-lg-2 mb-3 ${className ?? ""}`;

  return <div className={classes}>{props.children}</div>;
};
